export default "__VITE_ASSET__CZ4oZ4aY__"